import { render, staticRenderFns } from "./MaterialsTable.vue?vue&type=template&id=5c09086c&"
import script from "./MaterialsTable.vue?vue&type=script&lang=js&"
export * from "./MaterialsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports